import { Action } from 'redux';
import { ItemListFilters, ItemModel } from '../../../api/core/core.types';
import { Page } from '../../../api/api.types';

export const GET_ITEM_LIST = 'GET_ITEM_LIST';
export const GET_ITEM = 'GET_ITEM';
export const POST_ITEM = 'POST_ITEM';
export const PUT_ITEM = 'PUT_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const UPDATE_ITEM_FILTERS = 'UPDATE_ITEM_FILTERS';
export const GET_ALL_ITEMS = 'GET_ALL_ITEMS';

export interface GetItemListAction extends Action {
  type: typeof GET_ITEM_LIST;
  payload: {
    page: Page<ItemModel>;
  };
}

export interface GetAllItemsAction extends Action {
  type: typeof GET_ALL_ITEMS;
  payload: {
    items: ItemModel[] | [];
  };
}

export interface GetItemAction extends Action {
  type: typeof GET_ITEM;
  payload: {
    selectedItem: ItemModel | null;
  };
}

export interface PostItemAction extends Action {
  type: typeof POST_ITEM;
  payload: {
    success: boolean;
    newItem: ItemModel | null;
  };
}

export interface PutItemAction extends Action {
  type: typeof PUT_ITEM;
  payload: {
    selectedItem: ItemModel;
  };
}

export interface DeleteItemAction extends Action {
  type: typeof DELETE_ITEM;
  payload: {
    success: boolean;
  };
}

export interface UpdateItemFilters extends Action {
  type: typeof UPDATE_ITEM_FILTERS;
  payload: {
    filters: ItemListFilters;
  };
}

export interface ItemState {
  items: ItemModel[] | [];
  selectedItem: ItemModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalElements: number;
  totalPages: number;
  filters: ItemListFilters | null;
}

export type ItemActionTypes =
  GetItemListAction
  | GetItemAction
  | PostItemAction
  | DeleteItemAction
  | PutItemAction
  | UpdateItemFilters
  | GetAllItemsAction;
